import { request } from "utils/legacy_api";

export function getGeneralInfo() {
  return request("/performance?get=questionnaires&averages=true", {
    method: "GET"
  });
}

export function getQuestionnaires() {
  return request("/performance?get=questionnaires&averages=false", {
    method: "GET"
  });
}

export function getQuestionsBySubject() {
  return request("/performance?get=questions&group_by=subject", {
    method: "GET"
  });
}
